import { Component, OnInit, Input } from '@angular/core';
import { Amline } from 'src/app/model/quote/amline/amline.model';
import * as hbDisplay from '../../amlin-horsebox-display.util';

@Component({
  selector: 'app-am-full-details',
  templateUrl: './am-full-details.component.html',
  styleUrls: ['./am-full-details.component.css', '../../../quote.component.css']
})
export class AmFullDetailsComponent implements OnInit {
  quote;
  quoteApplicationData = new Amline();
  CoverTo;
  @Input() set quoteDetails(value: any) {
    if (value) {
      this.quote = value;
      this.quoteApplicationData = value.application;
    }
  }

  constructor() { }

  ngOnInit(): void {
  }

  getVehicleOvernightLines(v: any): string[] {
    return hbDisplay.getVehicleOvernightLines(v);
  }

  isKeptOvernightAtProposer(v: any): boolean {
    return hbDisplay.isKeptOvernightAtProposer(v);
  }

  correspondenceAddressLine(app: any): string | null {
    return hbDisplay.getCorrespondenceLine(app);
  }

}
